import { SVGProps } from 'react';

export const RangeOperatorGreaterThan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="15"
    viewBox="0 -2 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.90625 4.25391V6.43262L0 10.6973V8.02637L7.11719 5.32617L0 2.67188V0L9.90625 4.25391Z"
      fill="currentColor"
    />
  </svg>
);
